import { AutocompleteWithLabel } from '@adotel/components'
import { useLazyQuery } from '@apollo/client'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import React, { FC, useEffect } from 'react'

import { CHANNELS_QUERY } from '../../graphql/channel'
import {
  getEntityCode,
  getEntityId,
  getEntityName,
  getRoleFromStorage
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import inventoryPagesRoleManagement from '../../staticRoleManagement/inventoryRoleManagement'
import { Channel } from '../../types/channel'
import useStyles from './styles/InventoryBulkUpdate.style'

interface InventoryTypeSelectionProps {
  isChannelSelected: string
  setIsChannelSelected: React.Dispatch<React.SetStateAction<string>>
  selectedChannel: any[]
  setSelectedChannel: React.Dispatch<React.SetStateAction<any[]>>
  propertyCodes: string[]
}
const InventoryTypeSelection: FC<InventoryTypeSelectionProps> = ({
  isChannelSelected,
  setIsChannelSelected,
  selectedChannel,
  setSelectedChannel,
  propertyCodes
}) => {
  const classes = useStyles()
  const [getChannels, { data: channelsData, loading: loadingForChannelsList }] =
    useLazyQuery<{
      channels: Channel[]
    }>(CHANNELS_QUERY, {
      notifyOnNetworkStatusChange: true
    })

  const isRoleChannel = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.sections?.IS_CHANNEL.rolesListWithWriteAccess?.includes(
      getRoleFromStorage()
    )

  useEffect(() => {
    getChannels({
      variables: {
        propertiesCode: propertyCodes
      }
    })
  }, [propertyCodes])

  useEffect(() => {
    if (isRoleChannel) {
      setSelectedChannel([
        {
          label: getEntityName(),
          value: getEntityId(),
          code: getEntityCode()
        }
      ])
    }
  }, [loadingForChannelsList])

  useEffect(() => {
    if (isRoleChannel) {
      setIsChannelSelected('Channel')
    }
  }, [])

  return (
    <div className={classes.inventoryTypeFormContainer}>
      <div className={classes.inventoryTypeSelector}>
        <Typography className={classes.inventoryTypeSelectorLabel}>
          {getTranslate('Inventory Type')}:
        </Typography>
        <RadioGroup
          className={classes.inventoryTypeRadioGroup}
          value={isChannelSelected}
          onChange={(event) => setIsChannelSelected(event.target.value)}>
          <FormControlLabel
            disabled={isRoleChannel}
            value="CRS"
            control={<Radio color="primary" />}
            label={getTranslate('CRS')}
          />
          <FormControlLabel
            disabled={isRoleChannel}
            value="Channel"
            control={<Radio color="primary" />}
            label={getTranslate('Channel')}
          />
        </RadioGroup>
      </div>
      {isChannelSelected === 'Channel' && (
        <div className={classes.channelSelector}>
          <AutocompleteWithLabel
            value={selectedChannel}
            label={getTranslate('Channels')}
            placeholder={getTranslate('Select channels')}
            includeInputInList
            onChange={(_, v: any) => {
              const selectedChannels: any[] = []
              v.map((value: any) =>
                selectedChannels.push({
                  value: value.value,
                  code: value.code,
                  label: value.label
                })
              )
              setSelectedChannel(selectedChannels)
            }}
            getOptionSelected={(option, value) =>
              option.value === value.value && option.label === value.label
            }
            disabled={isRoleChannel}
            limitTags={2}
            multiple
            getOptionLabel={(option) => option.label || ''}
            options={
              channelsData
                ? channelsData?.channels.map((item) => ({
                    label: item.basicDetails.name,
                    value: item.basicDetails.channelID || '',
                    code: item.basicDetails.displayChannelCode
                  }))
                : [{ label: getTranslate('Nothing found'), value: '' }]
            }
            size="small"
            inputSize="small"
            loading={loadingForChannelsList}
            loadingText={getTranslate('Loading') + '...'}
          />
        </div>
      )}
    </div>
  )
}

export default InventoryTypeSelection
